<script lang="ts" module>
  export const timer = new Timer({});
</script>

<script lang="ts">
  import { onMount } from 'svelte';
  import Clock from '~icons/mdi/clock-time-four-outline';
  import { formatSeconds, getTimeTilNextPuzzle } from '../utils/dates';
  import Spinner from './Spinner.svelte';
  import { latestDailyQuery } from '~/lib/queries.svelte';
  import Timer from '../timer/timer.svelte';
  import type { DailyVariant } from '~/store/game.svelte';

  type Props = {
    variant: DailyVariant;
  };
  const props: Props = $props();
  const latestDaily = $derived(latestDailyQuery(props.variant));

  onMount(() => {
    if (latestDaily.data?.completed) {
      start(latestDaily.data.date);
    }

    return () => {
      timer.pause();
    };
  });

  // restart timer when daily status changes;
  $effect(() => {
    if (latestDaily.data?.completed) {
      start(latestDaily.data.date);
    }
  });

  const start = (date: string) => {
    const timeTil = getTimeTilNextPuzzle(date);
    if (timeTil <= 0) {
      // the timer is a module singleton; clear any tick left over from a
      // previous mount so GameOver's `$timer === 0` check can pass
      timer.pause();
      timer.update(0);
      latestDaily.refetch();
    } else {
      timer.start({
        durationMs: timeTil,
        onComplete: () => {
          // avoid infinite loop
          if (!latestDaily.isFetching) {
            latestDaily.refetch();
          }
        },
      });
    }
  };
</script>

{#if latestDaily.isFetching}
  <div class="daily-timer">
    <Spinner />
  </div>
{:else if $timer > 0}
  <div class="daily-timer">
    <Clock size={20} />
    Next Puzzle in
    <span class="timer">{formatSeconds($timer)}</span>
  </div>
{/if}

<style>
  .daily-timer {
    width: 100%;
    height: 1em;
    margin-bottom: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
  }
  .timer {
    font-size: 1rem;
    font-family: monospace;
  }
</style>
